/*
 * @Description: 配置
 * @Author:
 * @Date: 2022-09-21 22:17:23
 * @LastEditors: 裴孚
 */
import axios from 'axios'
import { warningPrompt, errorPrompt } from '../utils/promptInfo'
import { backToLogin } from '../utils/login.js'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API
})

// 请求拦截器
service.interceptors.request.use((config) => {
  if ($cookies.get('access_token')) {
    config.headers.access_token = $cookies.get('access_token')
    return config
  } else {
    backToLogin()
  }
}, (error) => {
  return Promise.reject(error)
})

// 响应拦截
service.interceptors.response.use((response) => {
  const meta = response.data
  if (meta.code === 200) {
    return response.data
  } else if (meta.code === 500) {
    if (response.data.message === '您没有访问权限，请重新登录') {
      backToLogin()
    }
    return warningPrompt(response.data.message)
  } else if (meta.code === 999) {
    backToLogin()
    return warningPrompt(response.data.message)
  } else {
    return warningPrompt('code不符合规范')
  }
}, (error) => {
  return errorPrompt(error)
})
export default service
